
import Backward from "@/assets/icons/backward.png"
import Forward from "@/assets/icons/forward.png"
import MiniBackward from "@/assets/icons/miniBackward.png"
import MiniForward from "@/assets/icons/miniForward.png"
import WhiteTick from "@/assets/icons/whiteTick.png"
import Setting from "@/assets/icons/setting.png"

import "./style.css"

export default function VideoPlayerMainView(props: any) {

    return (
        <>

            {/* dummy div so there is no UI shift */}
            {props.finalIsLoading &&
                <div
                    className="dummyUiVideoPlayer"></div>
            }

            <div
                style={{
                    display: props.finalIsLoading ? 'none' : 'block'
                }}
                ref={props.playerContainerRef}
                // className="videoPlayerMainView0">
                className={`videoPlayerMainView0 ${props.isManualFullscreen ? 'manual-fullscreen-mode' : ''}`}>


                <div
                    ref={props.domVideoElementRef}
                    // className="vimeo-player-container" />
                    className={`vimeo-player-container ${props.isManualFullscreen ? 'fullScreenMiddleDiv' : ''}`} />


                <div
                    className={`videoPlayerMainView 
                                ${props.showControls ? 'videoPlayerMainView_shadow' : ''}`}

                    onMouseEnter={props.handleMouseEnter}
                    onMouseLeave={props.handleMouseLeave}
                >
                    <div
                        onClick={() => { props.handlePlayPauseOfVideo("click") }}
                        className="div00">
                        <div className="div0">
                            {props.playPauseIcon != "" &&
                                <>
                                    <img
                                        style={{
                                            visibility: (props.showControls || props.isVisibleBackwardIcon) ? 'visible' : 'hidden'
                                        }}
                                        onClick={(e) => { props.handleBackward10(e) }}
                                        className={`forwardBackwardIcon`}
                                        src={Backward} alt="Backward" />


                                    {props.playPauseIcon !== "" && (
                                        <img
                                            style={{
                                                visibility: props.showControls ? 'visible' : 'hidden'
                                            }}
                                            onClick={() => { props.handlePlayPauseOfVideo("playPauseIcon") }}
                                            className="playPauseIcon"
                                            src={props.playPauseIcon} alt="playPauseIcon" />

                                    )}

                                    <img
                                        style={{
                                            visibility: (props.showControls || props.isVisibleForwardIcon) ? 'visible' : 'hidden'
                                        }}
                                        onClick={(e) => { props.handleForward10(e) }}
                                        className="forwardBackwardIcon"
                                        src={Forward} alt="Forward" />
                                </>
                            }
                        </div>
                    </div>


                    <div className="desktopDiv1">
                        <div
                            className="speedCon"
                            ref={props.speedConRef}>
                            {Object.entries(props.speedList).map(([label, value]) => (
                                <p
                                    key={label}
                                    onClick={(event) => { props.handleSpeed(event, value) }}
                                    className="p1">
                                    {props.speedValue === value &&
                                        <img src={WhiteTick} alt="WhiteTick" />
                                    }
                                    {label}
                                </p>
                            ))}
                        </div>

                        <div
                            className="qtyCon"
                            ref={props.qtyConRef}
                        >
                            {props.availableQualities.map((qty: any, index: number) => (
                                <p
                                    key={index}
                                    onClick={(event) => { props.handleQty(event, qty) }}
                                    className="p1">
                                    {props.qtyValue === qty.id &&
                                        <img src={WhiteTick} alt="WhiteTick" />
                                    }
                                    {qty.label}
                                </p>
                            ))}
                        </div>
                    </div>


                    <div
                        style={{ display: (props.showControls && props.miniPlayPauseIcon !== null) ? 'block' : 'none' }}
                        className="desktopDiv2">
                        <input
                            ref={props.timeBarRef}
                            type="range"
                            min="0"
                            max="0"
                            step="0.1"
                            className="timeBar"
                            style={{ backgroundSize: `${props.timeBarChangePer} 100%` }}
                            onChange={(event) => { props.handleTimeBarRefChange(event); }}
                        />
                    </div>


                    <div
                        style={{ display: (props.showControls && props.miniPlayPauseIcon !== null) ? 'flex' : 'none' }}
                        className="desktopDiv3">
                        <div className="lhsCon_desktopDiv3">
                            <img
                                onClick={() => { props.handlePlayPauseOfVideo("miniPlayPauseBtnRef") }}
                                ref={props.miniPlayPauseBtnRef}
                                className="miniControlIcons hideInMobile"
                                src={props.miniPlayPauseIcon} alt="miniPlayPauseIcon" />

                            <img
                                onClick={(e) => { props.handleBackward10(e) }}
                                ref={props.miniBackwardBtnRef}
                                className="miniControlIcons01 hideInMobile"
                                src={MiniBackward} alt="MiniBackward" />

                            <img
                                onClick={props.handleSpeedContainerVisibility}
                                className="miniControlIcons hideInMobile"
                                src={props.speedIcon} alt="speedIcon" />

                            <img
                                onClick={(e) => { props.handleForward10(e) }}
                                className="miniControlIcons01 hideInMobile"
                                src={MiniForward} alt="MiniForward" />


                            <p className="videoTimeCon">
                                <span>{props.currentVideoTime}</span>
                                {' / '}
                                <span>{props.videoDuration}</span>
                            </p>
                        </div>

                        <div className="rhsCon_desktopDiv3">
                            <div
                                className="volumeCon"
                            >
                                <img
                                    onClick={props.handleVolumeBtn}
                                    className="miniControlIcons"
                                    src={props.volumeIcon}
                                    alt="volumeIcon" />
                                {/* {props.volumeBarRef.current?.value} */}
                                <input
                                    ref={props.volumeBarRef}
                                    className="volumeBar hideInMobile"
                                    type="range"
                                    min="0"
                                    max="1"
                                    step="0.1"
                                    style={{ backgroundSize: `${props.volumeBarChangePer} 100%` }}
                                    onChange={(event) => { props.handleVolumeChange(event, 0); }}
                                />
                            </div>


                            <img
                                ref={props.qtyImgIconRef}
                                onClick={props.handleQtyContainerVisibility}
                                src={Setting}
                                className="miniControlIcons"
                                alt="Setting" />

                            <img
                                onClick={props.handleSpeedContainerVisibility}
                                className="miniControlIcons showInMobile"
                                src={props.speedIcon} alt="speedIcon" />


                            {props.isHasCaptions.current &&
                                <img
                                    onClick={props.handleCC}
                                    src={props.ccIcon}
                                    className="miniControlIcons"
                                    alt="ccIcon" />
                            }

                            <img
                                onClick={props.toggleFullscreen}
                                className="miniControlIcons"
                                src={props.fullSmallScreenIcon}
                                alt="fullScreen" />
                        </div>
                    </div>

                </div>

            </div>
        </>
    );
}
